import * as React from 'react';

import FileCode32 from './FileCode32';

export const fileCode32 = () => <FileCode32 />;

export default {
    title: 'Icon/Content/FileCode32',
    component: FileCode32,
    parameters: {
        notes: "`import FileCode32 from 'box-ui-elements/es/icon/content/FileCode32';`",
    },
};
